export const END_POINT = 'https://api.podcast.adzdata.com/graphql';
export const REST_ENDPOINT = 'https://api.podcast.adzdata.com';
export const MASTER_API_KEY = 'e678b5ed-735f-4213-8bd1-1a73c925b9cd';
